import React from 'react';

import LinearProgress from '@mui/material/LinearProgress';
import { Box, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import EmptyState from 'common/components/EmptyState';

import EmptyProjects from 'resources/EmptyProjects.svg?react';

import ListItems from './ListItems';

const EmptyStateAndList = ({
    filterData,
    handleClickBulkItems,
    handleClickCreate,
    handleSaveRow,
    isFetching,
    paginationData,
    projects,
    rowCount,
    selectionModel,
    setFilterData,
    setSelectionModel,
    showEmptyState,
    tableSettings,
}) => {
    const { t } = useTranslation();

    if (isFetching)
        return (
            <Box height={460}>
                <LinearProgress />
            </Box>
        );

    if (!isFetching && showEmptyState.show)
        return (
            <Grid container justifyContent="center">
                <Grid size="grow">
                    {showEmptyState?.status === 'active' ? (
                        <EmptyState
                            caption={t(
                                'Create a new project and store all related proposals in it',
                            )}
                            onClick={() => handleClickCreate()}
                            srcSvg={<EmptyProjects />}
                            sxCard={{ border: 0, boxShadow: 'none' }}
                            textButton={t('Create')}
                            title={t('No active projects')}
                        />
                    ) : (
                        <EmptyState
                            srcSvg={<EmptyProjects />}
                            sxCard={{ border: 0, boxShadow: 'none' }}
                            title={t('No archived projects')}
                        />
                    )}
                </Grid>
            </Grid>
        );

    return (
        <ListItems
            filterData={filterData}
            handleClickBulkItems={handleClickBulkItems}
            handleSaveRow={handleSaveRow}
            isFetching={isFetching}
            items={projects}
            paginationData={paginationData}
            rowCount={rowCount}
            selectionModel={selectionModel}
            setFilterData={setFilterData}
            setSelectionModel={setSelectionModel}
            tableSettings={tableSettings}
        />
    );
};

EmptyStateAndList.propTypes = {
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickCreate: PropTypes.func,
    handleSaveRow: PropTypes.func,
    isFetching: PropTypes.bool,
    paginationData: PropTypes.object,
    projects: PropTypes.array,
    rowCount: PropTypes.number,
    selectionModel: PropTypes.array,
    setFilterData: PropTypes.func,
    setSelectionModel: PropTypes.func,
    showEmptyState: PropTypes.object,
    tableSettings: PropTypes.array,
};

export default EmptyStateAndList;
